'use strict';
'use client';
import { j as s } from "../../external/react/jsx-runtime.js";
import m from "../../external/classnames/index.js";
import { useTheme as t } from "../Provider/index.js";
const p = ({ active: e, step: i, First: l, Last: o }) => {
  const { isMosh: r, isMoshy: n } = t(), d = m("h-8 w-8 rounded-full p-2", {
    "bg-green-light": e && r,
    "bg-purple-extra-light": e && n,
    "-mt-2": !l && e
  }), g = m("h-4 w-4 rounded-full", {
    "bg-green-faint-light": e && r,
    "bg-purple": e && n,
    "bg-grey-200": !e,
    "-mt-2": !l && !e
  });
  return /* @__PURE__ */ s.jsxs("div", { className: "flex gap-4", children: [
    /* @__PURE__ */ s.jsxs("div", { className: "flex flex-col items-center", children: [
      l ? null : /* @__PURE__ */ s.jsx("div", { className: "h-2 w-[1px] bg-grey-200" }),
      /* @__PURE__ */ s.jsx("div", { className: d, children: /* @__PURE__ */ s.jsx("div", { className: g }) }),
      o ? null : /* @__PURE__ */ s.jsx("div", { className: "-z-10 -mt-4 h-full w-[1px] bg-grey-200" })
    ] }),
    /* @__PURE__ */ s.jsx("div", { children: i })
  ] });
};
export {
  p as default
};
